import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { CustomHammerConfig } from './custom-hammer-config.service';
import { NgxGalleryActionComponent } from './ngx-gallery-action.component';
import { NgxGalleryArrowsComponent } from './ngx-gallery-arrows.component';
import { NgxGalleryDescriptionComponent } from './ngx-gallery-description.component';
import { NgxGalleryImageComponent } from './ngx-gallery-image.component';
import { NgxGalleryPreviewComponent } from './ngx-gallery-preview.component';
import { NgxGalleryThumbnailsComponent } from './ngx-gallery-thumbnails.component';
import { NgxGalleryComponent } from './ngx-gallery.component';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SafeResourceUrl } from './safe-resource-url.pipe';
import { PdfViewerModule } from '../pdf-viewer/pdf-viewer.module';

@NgModule({
  imports: [CommonModule, PdfViewerModule],
  declarations: [
    NgxGalleryActionComponent,
    NgxGalleryArrowsComponent,
    NgxGalleryDescriptionComponent,
    NgxGalleryImageComponent,
    NgxGalleryThumbnailsComponent,
    NgxGalleryPreviewComponent,
    NgxGalleryComponent,
    SafeHtmlPipe,
    SafeResourceUrl,
  ],
  exports: [NgxGalleryComponent],
  providers: [{ provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig }],
})
export class NgxGalleryModule {}
